/**
 * This utility is used for locking the screen in an awake state (preventing sleep).
 * Main purpose is for kiosk applications like IPEX Gallery.
 */
export default class KeepScreenAwakeUtility {
	/**
	 * Keeps the screen on.
	 */
	public static async setWakeLock(): Promise<void> {
		const typedNavigator: any = navigator;
		if ('wakeLock' in typedNavigator) {
			await typedNavigator['wakeLock'].request('screen');
		}
	}
}
